// extracted by mini-css-extract-plugin
export default {"container":"VkhofE","button":"I_QKM9","right":"yWmZJV","left":"Az4z5A"};